import { combineEpics } from "redux-observable";
import { p as provideSrmDebugEpics } from "../SrmDebug.ducks-944cbd53.js";
import history from "@ane/core/lib/CreateHistory";
const rootEpic = combineEpics(provideSrmDebugEpics(history));
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
